import { Component } from '@angular/core';
import { SystemSiteService } from 'app/services/system-site.service';
import { Subscription } from 'rxjs';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  socialData: any = []
  socialSubscription: Subscription = null;
  is_international = environment.is_international;
  constructor( private systemSiteService: SystemSiteService) { }

  currentYear = new Date().getFullYear(); // 2020

  ngOnInit(): void {

    this.LoadData();

  }

  LoadData() {
    this.socialSubscription = this.systemSiteService.get_social().subscribe({ next: data => {
      console.log(data.result_data)
      this.socialData = data.result_data;
    },
      error: error => { console.log(error) },
  })
  }



}
